import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Pagination from "@material-ui/lab/Pagination";

import AddCircleIcon from "@material-ui/icons/AddCircle";

import { useStyles } from "../../UserAssignments.css";
import ClassAssignmentForm from "../ClassAssignmentForm/ClassAssignmentForm";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import AddAssignment from "../AddAssignment/AddAssignment";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import AssignmentBody from "../AssignmentBody/AssignmentBody";
import { getUserRefreshToken } from "../../../../../Redux/Actions/actions";
import MobileAddAssignment from "../AddAssignment/MobileAddAssignment";
import MobileAssignmentBody from "../AssignmentBody/MobileAssignmentBody";

class ViewAssignment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 10,
      page: 0,
      currentPage: 1,
      postPerPage: 5,
      data: {
        session: new Date().getFullYear(),
        class: "",
        faculty: "",
        group: "",
        section: "",
      },
      column: [
        {
          name: "S.N",
        },
        { name: "Title" },
        { name: "Assignment Files" },
        { name: "Subject" },
        { name: "Deadline" },
        { name: "Actions" },
      ],
      assignments: [],
      detailStatus: false,
      subjects: [],
      addStatus: false,
      loading: false,
    };
  }

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  handleMobilePage = (e, value) => {
    this.setState({
      currentPage: value,
    });
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleChangeClass = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        class: e.target.value,
        faculty: "",
        group: "",
        section: "",
      },
    });
  };

  handleAddStatus = (addStatus) => {
    this.setState({ addStatus });
  };

  getAssignments = async () => {
    try {
      const response = await Axios.get(`${url}/api/assignments`, {
        params: {
          studentClass: this.state.data.class,
          faculty: this.state.data.faculty ? this.state.data.faculty : "",
          group: this.state.data.group ? this.state.data.group : "",
          section: this.state.data.section,
          teacherId: this.props.userId,
        },
        headers: {
          Authorization: `Bearer ${this.props.userToken}`,
        },
      });
      if (response.data.assignments.length !== 0) {
        this.setState({
          assignments: response.data.assignments,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getAssignments();
      }
    }
  };

  handleSubmit = async (e, subjects) => {
    e.preventDefault();
    try {
      this.setState({ loading: true });
      if (subjects.length !== 0) {
        this.getAssignments();
        this.setState({
          detailStatus: true,
          subjects,
          loading: false,
        });
      }
    } catch (error) {
      this.setState({ loading: false });
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.handleSubmit(e, subjects);
      }
    }
  };

  render() {
    const { rowsPerPage, page, postPerPage, currentPage } = this.state;
    const { classes } = this.props;
    return (
      <div>
        <ClassAssignmentForm
          loading={this.state.loading}
          buttonLabel="Set Assignments"
          handleChangeClass={this.handleChangeClass}
          data={this.state.data}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
        />
        {this.state.detailStatus && (
          <div>
            <div className={classes.sectionDesktop}>
              <TableContainer>
                <Table>
                  <CustomTableHead column={this.state.column} />

                  <TableBody>
                    <AddAssignment
                      config={this.state.data}
                      subjects={this.state.subjects}
                      getAssignments={this.getAssignments}
                    />
                    {this.state.assignments.length !== 0 &&
                      this.state.assignments.map((assignment, index) => (
                        <AssignmentBody
                          key={index}
                          index={index}
                          data={assignment}
                          getAssignments={this.getAssignments}
                        />
                      ))}
                  </TableBody>

                  <CustomTableFooter
                    count={this.state.assignments.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={this.handlePage}
                    onChangeRowsPerPage={this.handleRowsPerPage}
                  />
                </Table>
              </TableContainer>
            </div>
            <div className={classes.sectionMobile}>
              <br />
              {this.state.addStatus === false && (
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  onClick={() => this.handleAddStatus(true)}
                >
                  <Tooltip arrow title="Add">
                    <AddCircleIcon />
                  </Tooltip>
                  <div>Add Assignment</div>
                </div>
              )}
              <br />
              {this.state.addStatus && (
                <MobileAddAssignment
                  handleAddStatus={this.handleAddStatus}
                  config={this.state.data}
                  subjects={this.state.subjects}
                  getAssignments={this.getAssignments}
                />
              )}
              <br />
              {this.state.assignments.length !== 0 && (
                <Grid container spacing={3}>
                  {this.state.assignments.map((assignment, index) => (
                    <Grid item xs={12} sm={12} md={6} key={index}>
                      <MobileAssignmentBody
                        data={assignment}
                        getAssignments={this.getAssignments}
                      />
                    </Grid>
                  ))}
                  <Grid item xs={12} sm={12} md={12}>
                    <Pagination
                      count={Math.ceil(
                        this.state.assignments.length / postPerPage
                      )}
                      color="secondary"
                      page={currentPage}
                      boundaryCount={1}
                      onChange={this.handleMobilePage}
                      showFirstButton
                      showLastButton
                    />
                  </Grid>
                </Grid>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewAssignment)));
